export default [{
    name: 'accredited',
    categoryTitle: 'An Accredited Investor',
    options: [{
        value: 'accredited_1',
        text: 'Either alone or with my spouse, I own more than $1 million in cash and securities (financial assets), after subtracting any debt related to the cash and securities (The value of your residence or other real estate is not included in this calculation).'
    }, {
        value: 'accredited_2',
        text: 'I have net income before taxes exceeding $200,000 in each of the 2 most recent calendar years, and I expect it to be more than $200,000 in this calendar year.'
    }, {
        value: 'accredited_3',
        text: 'I have net income before taxes exceeding $300,000 when combined with my spouse, in each of the 2 most recent calendar years, and I expect it to be more than $300,000 in this calendar year.'
    }, {
        value: 'accredited_4',
        text: 'I have net assets, either alone or with a spouse, of at least $5 million. Net assets are your total assets (including real estate) minus your debt.'
    }, {
        value: 'accredited_5',
        text: 'I am registered or was formerly registered under the securities legislation of a jurisdiction of Canada as a representative of a registered advisor or dealer other than a limited market dealer.'
    }]
}, {
    name: 'eligible',
    categoryTitle: 'An Eligible Investor',
    options: [{
        value: 'eligible_1',
        text: 'Either alone or with my spouse, I have net assets exceeding $400,000. Net assets are your total assets minus your debt.'
    }, {
        value: 'eligible_2',
        text: 'I have net income before taxes exceeding $75,000 in each of the 2 most recent calendar years, and I expect it to be more than $75,000 in this calendar year.'
    }, {
        value: 'eligible_3',
        text: 'I have net income before taxes exceeding $125,000 when combined with my spouse, in each of the 2 most recent calendar years, and I expect it to be more than $125,000 in this calendar year.'
    }]
}, {
    name: 'other',
    categoryTitle: 'Other',
    options: [{
        value: 'other',
        text: 'I understand there may be limits to the amount I can invest.'
    }]
}, {
    name: 'permitted',
    categoryTitle: 'Permitted client or registered securities advisor – no advice',
    options: [{
        value: 'permitted_1',
        text: 'I beneficially own financial assets having an aggregate realizable value that, before taxes but net of any related liabilities, exceeds $5 million and as such, waive my right to rely on advice on the suitability of my purchase of securities (Financial assets include cash, securities or a contract of insurance deposit or evidence of a deposit that is not a security for the purposes of securities legislation. The value of your residence or other real estate is not included in the calculation of financial assets)'
    }, {
        value: 'permitted_2',
        text: 'I am registered under the securities legislation of a jurisdiction of Canada as a representative of a registered advisor or dealer other than a limited market dealer and as such, waive my right to rely on advice on the suitability of my purchase of securities'
    }, {
        value: 'permitted_3',
        text: 'I am acting on behalf of a managed account managed by me, and I am registered or authorized to carry on business as an adviser or the equivalent under the securities legislation of a jurisdiction of Canada or a foreign jurisdiction'
    }]
}]
